import { render, staticRenderFns } from "./ShowOrder.vue?vue&type=template&id=3d90a4e3&"
import script from "./ShowOrder.vue?vue&type=script&lang=ts&"
export * from "./ShowOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports